import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('location_audit')
export class LocationAudit {
    @PrimaryGeneratedColumn('increment',{
        name:'audit_id'
    })
    auditId : number;

    @Column('int', {
        name:'location_id'
    })
    locationId: number;

    @Column('varchar', {
        name:'audit_type'
    })
    auditType : string;

    @Column({
        name: 'audit_date',
        type: 'datetime'
    })
    auditDate: Date;

    @Column({
        name: 'start_date',
        type: 'datetime'
    })
    startDate: Date;

    @Column({
        name: 'completed_date',
        type: 'datetime'
    })
    completedDate: Date;

    @Column('varchar', {
        name:'audit_provider'
    })
    auditProvider : string;

    @Column('varchar', {
        name:'audit_name'
    })
    auditName : string;
    
    @Column('varchar', {
        name:'audit_owner'
    })
    auditOwner : string;

    @Column('varchar', {
        name:'phone_number'
    })
    phoneNumber : string;

    @Column('int', {
        name:'working'
    })
    working: number;

    
    @Column('int', {
        name:'not_working'
    })
    Notworking: number;

    @Column('varchar', {
        name:'status'
    })
    status : string;

    @Column('varchar', {
        name:'remarks'
    })
    remarks : string;

    @Column('varchar', {
        name:'reason'
    })
    reason : string;

    @Column('boolean', {
        name:'is_active',
        default: true,
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column("int", {
        name:"assets_count"
    })
    assetsCount : number;
}